import {ISelectOption} from '../../utils/core/_model'
import {IRouteOptions} from './modal/RouteManageForm'

export interface RouteManageFormValuesType {
  name: string
  type: string
  sourceSenderIds: number[] | null
  destinationSenderIds: number[] | null
  condition: string
  status: string
  sourceRoute: IRouteOptions | null
  source: string[] | string | null
  destinationRoute: IRouteOptions | null
  destination: string[] | string | null
  senderId: string | null
  sourceId: number | null
  destinationId: number | null
}

// Old interface for roles
export interface IRouteSenderRoles {
  id: number
  name: string
  source: string
  destination: string
  sender_id: string
  status: string
  type: string
  sourceId: number
  destinationName: string
  route_url_status: string
  created_at: string
  sourceName: string
  destinationId: number
}

export interface IRoles {
  name: string
  type: string
}

export interface IRolesDetails {
  id: 4
  name: string
  source: string
  destination: string
  sender_id: string
  status: string
  type: string
  route_url_status: string
}

export interface IRouteSenderDetails {
  destinationSenderId: number
  insDate: string
  sourceRoute: number
  sourceSenderId: number
  lastUpdate: string
  rolesId: number
  destinationSender: string
  altId: number
  sourceSender: string
  destRoute: number
  status: number
  sourceRouteName: string
  destinationRouteName: string
}

export interface IAddSenderFormValues {
  sourceSender: ISelectOption[]
  destinationSender: ISelectOption[]
  sourceSenderId: number[]
  destinatioSenderId: number[]
  status: string
}

export const initAddSenderFormValues: IAddSenderFormValues = {
  sourceSender: [],
  destinationSender: [],
  sourceSenderId: [],
  destinatioSenderId: [],
  status: '',
}

export const initRouteManageFormValeus: RouteManageFormValuesType = {
  name: '',
  type: '',
  sourceSenderIds: null,
  destinationSenderIds: null,
  condition: '',
  status: '',
  sourceRoute: null,
  source: null,
  destinationRoute: null,
  destination: null,
  senderId: null,
  sourceId: null,
  destinationId: null,
}

export const overwriteOptions = [
  {
    id: 1,
    value: 'Sender',
    label: 'Sender',
  },
  {
    id: 2,
    value: 'Route',
    label: 'Route',
  },
]

export const statusOptions = [
  {
    id: 1,
    value: 'Inactive',
    label: 'Inactive',
  },
  {
    id: 2,
    value: 'Active',
    label: 'Active',
  },
]
